import { render, staticRenderFns } from "./CattleNew.vue?vue&type=template&id=aac9e446&scoped=true"
import script from "./CattleNew.vue?vue&type=script&lang=js"
export * from "./CattleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac9e446",
  null
  
)

export default component.exports